import { Grid } from "@mui/material";
import { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { H4 } from "../../components/Typography";
import { load } from "../../constants/storage";

const EsignComplete: FC = () => {
  let userDetail: any = load("userData");
  let userDetails = JSON.parse(userDetail);
  let navigate = useNavigate();
  setTimeout(() => {
    if (userDetails?.mode === "Assisted") {
      navigate("/assistedEsign");
    } else {
      navigate("/esign");
    }
  }, 5000);

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress />
      <H4 sx={{ mt: 2 }}>We are processing your Esign</H4>
      <H4>Please wait</H4>
    </Grid>
  );
};

export default EsignComplete;
